var _rect, _path, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlatinumIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 40,
    viewBox: "0 0 140 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 140,
    height: 40,
    rx: 20,
    fill: "#353535"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.6562 25H40.1875V21.6299H42.498C44.4326 21.6299 45.7725 20.3105 45.7725 18.3828V18.3691C45.7725 16.4346 44.4326 15.1357 42.498 15.1357H38.6562V25ZM42.1152 16.4277C43.4414 16.4277 44.2139 17.1455 44.2139 18.376V18.3896C44.2139 19.627 43.4414 20.3447 42.1152 20.3447H40.1875V16.4277H42.1152ZM47.6455 25H49.1289V14.6641H47.6455V25ZM53.374 25.123C54.3584 25.123 55.1377 24.6992 55.5752 23.9473H55.6914V25H57.1611V19.9209C57.1611 18.3623 56.1084 17.4326 54.2422 17.4326C52.5537 17.4326 51.3848 18.2461 51.207 19.4629L51.2002 19.5107H52.6289L52.6357 19.4834C52.8135 18.957 53.3535 18.6562 54.1738 18.6562C55.1787 18.6562 55.6914 19.1074 55.6914 19.9209V20.5771L53.6816 20.6934C51.9111 20.8027 50.9131 21.5752 50.9131 22.9014V22.915C50.9131 24.2617 51.959 25.123 53.374 25.123ZM52.3896 22.8535V22.8398C52.3896 22.1699 52.8545 21.8008 53.8799 21.7393L55.6914 21.623V22.2588C55.6914 23.2158 54.8779 23.9404 53.7705 23.9404C52.9707 23.9404 52.3896 23.5371 52.3896 22.8535ZM62.0557 25.0479C62.3428 25.0479 62.6162 25.0137 62.8555 24.9727V23.79C62.6504 23.8105 62.5205 23.8174 62.2949 23.8174C61.5635 23.8174 61.2627 23.4893 61.2627 22.6895V18.7451H62.8555V17.5762H61.2627V15.7031H59.752V17.5762H58.5898V18.7451H59.752V23.0449C59.752 24.4736 60.4219 25.0479 62.0557 25.0479ZM65.3574 16.25C65.8633 16.25 66.2871 15.833 66.2871 15.3271C66.2871 14.8145 65.8633 14.3975 65.3574 14.3975C64.8447 14.3975 64.4277 14.8145 64.4277 15.3271C64.4277 15.833 64.8447 16.25 65.3574 16.25ZM64.6123 25H66.0889V17.5762H64.6123V25ZM68.249 25H69.7324V20.6455C69.7324 19.4492 70.4092 18.7041 71.4961 18.7041C72.583 18.7041 73.0957 19.3125 73.0957 20.543V25H74.5723V20.1943C74.5723 18.4238 73.6562 17.4326 71.9951 17.4326C70.915 17.4326 70.2041 17.9111 69.8418 18.7041H69.7324V17.5762H68.249V25ZM79.1182 25.1436C80.1982 25.1436 80.9502 24.6787 81.3057 23.8789H81.4219V25H82.8984V17.5762H81.4219V21.9307C81.4219 23.127 80.7861 23.8721 79.5967 23.8721C78.5098 23.8721 78.0586 23.2637 78.0586 22.0332V17.5762H76.5752V22.3818C76.5752 24.1387 77.4434 25.1436 79.1182 25.1436ZM85.0381 25H86.5215V20.4404C86.5215 19.4697 87.1846 18.7041 88.0801 18.7041C88.9551 18.7041 89.5088 19.2373 89.5088 20.085V25H90.9854V20.3037C90.9854 19.4082 91.6074 18.7041 92.5508 18.7041C93.5215 18.7041 93.9863 19.21 93.9863 20.2354V25H95.4629V19.8799C95.4629 18.335 94.5879 17.4326 93.0908 17.4326C92.0586 17.4326 91.2041 17.959 90.8281 18.7588H90.7119C90.3838 17.959 89.666 17.4326 88.6543 17.4326C87.6836 17.4326 86.959 17.9043 86.6309 18.7178H86.5215V17.5762H85.0381V25ZM101.109 21.7051H104.131V24.7402H105.484V21.7051H108.513V20.3447H105.484V17.3096H104.131V20.3447H101.109V21.7051ZM112.812 25H114.344V15.1357H112.812L110.215 16.9814V18.4854L112.696 16.7148H112.812V25ZM119.108 20.4062C120.435 20.4062 121.241 19.3604 121.241 17.6992V17.6924C121.241 16.0312 120.435 14.999 119.108 14.999C117.782 14.999 116.976 16.0312 116.976 17.6924V17.6992C116.976 19.3604 117.782 20.4062 119.108 20.4062ZM120.127 25L126.812 15.1357H125.534L118.849 25H120.127ZM119.108 19.4902C118.459 19.4902 118.09 18.8271 118.09 17.6992V17.6924C118.09 16.5713 118.459 15.915 119.108 15.915C119.758 15.915 120.134 16.5713 120.134 17.6924V17.6992C120.134 18.8271 119.758 19.4902 119.108 19.4902ZM126.546 25.1367C127.872 25.1367 128.679 24.0977 128.679 22.4365V22.4297C128.679 20.7686 127.872 19.7295 126.546 19.7295C125.22 19.7295 124.413 20.7686 124.413 22.4297V22.4365C124.413 24.0977 125.22 25.1367 126.546 25.1367ZM126.546 24.2207C125.896 24.2207 125.527 23.5576 125.527 22.4365V22.4297C125.527 21.3018 125.896 20.6455 126.546 20.6455C127.195 20.6455 127.564 21.3018 127.564 22.4297V22.4365C127.564 23.5576 127.195 24.2207 126.546 24.2207Z",
    fill: "#C9C9C9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6267_1248)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 10,
    fill: "url(#paint0_linear_6267_1248)",
    shapeRendering: "crispEdges"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6267_1248)",
    filter: "url(#filter1_i_6267_1248)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6267_1248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5721 18.2695L22.0321 17.7555L20.4481 14.5475C20.4023 14.4689 20.3366 14.4036 20.2576 14.3583C20.1787 14.3129 20.0892 14.2891 19.9981 14.2891C19.9071 14.2891 19.8176 14.3129 19.7387 14.3583C19.6597 14.4036 19.594 14.4689 19.5481 14.5475L17.9681 17.7555L14.4281 18.2695C14.3358 18.2829 14.249 18.3219 14.1777 18.382C14.1064 18.4422 14.0533 18.5211 14.0244 18.6099C13.9956 18.6986 13.9922 18.7937 14.0146 18.8843C14.037 18.9749 14.0843 19.0574 14.1511 19.1225L16.7131 21.6225L16.1071 25.1485C16.0913 25.2405 16.1016 25.3351 16.1368 25.4216C16.1719 25.5081 16.2306 25.583 16.3062 25.6379C16.3818 25.6927 16.4712 25.7253 16.5643 25.732C16.6574 25.7386 16.7506 25.719 16.8331 25.6755L20.0001 24.0075L23.1671 25.6725C23.2386 25.7104 23.3183 25.73 23.3991 25.7295C23.472 25.7297 23.544 25.7139 23.6102 25.6833C23.6763 25.6527 23.7349 25.608 23.782 25.5524C23.8291 25.4968 23.8634 25.4315 23.8826 25.3612C23.9018 25.291 23.9054 25.2173 23.8931 25.1455L23.2871 21.6195L25.8491 19.1195C25.916 19.0544 25.9633 18.9719 25.9857 18.8813C26.0081 18.7907 26.0047 18.6956 25.9758 18.6069C25.947 18.5181 25.8939 18.4392 25.8226 18.379C25.7512 18.3189 25.6645 18.2799 25.5721 18.2665V18.2695Z",
    fill: "url(#paint1_linear_6267_1248)",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6267_1248",
    x: 8,
    y: 10,
    width: 24,
    height: 24,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6267_1248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6267_1248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_6267_1248",
    x: 14,
    y: 14,
    width: 12,
    height: 13,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_6267_1248"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6267_1248",
    x: 13,
    y: 14.2891,
    width: 14,
    height: 13.4434,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6267_1248"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6267_1248",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6267_1248",
    x1: 30,
    y1: 20,
    x2: 4.5,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6267_1248",
    x1: 30,
    y1: 20,
    x2: 13,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACACB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECECEC",
    stopOpacity: 0.5
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6267_1248"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatinumIcon);
export default __webpack_public_path__ + "static/media/platinum-icon.5236569b3b4e0f016e68d1e39569a67a.svg";
export { ForwardRef as ReactComponent };